import { apiHelpers } from './api';
import { LaborSafetyInstructionItem, ApiResponse, LaborSafetyInstructionItemFormData, LaborSafetyInstructionItemList } from '../types/models';
import { convertToUtcDate } from '../utils/dateUtils';

export class LaborSafetyInstructionItemService {
  // Получить все инструктажи по охране труда (упрощенная версия для списка)
  static async getAll(): Promise<ApiResponse<LaborSafetyInstructionItemList[]>> {
    return apiHelpers.get<LaborSafetyInstructionItemList[]>(`/LaborSafetyInstructionItem/GetAll`);
  }

  // Получить инструктаж по охране труда по ID
  static async getById(id: number): Promise<ApiResponse<LaborSafetyInstructionItem>> {
    return apiHelpers.get<LaborSafetyInstructionItem>(`/LaborSafetyInstructionItem/Get?id=${id}`);
  }

  // Получить инструктажи по охране труда по сотруднику (упрощенная версия для списка)
  static async getByEmployee(employeeId: number): Promise<ApiResponse<LaborSafetyInstructionItemList[]>> {
    return apiHelpers.get<LaborSafetyInstructionItemList[]>(`/LaborSafetyInstructionItem/GetByEmployee?employeeId=${employeeId}`);
  }

  // Создать новый инструктаж по охране труда
  static async create(data: LaborSafetyInstructionItemFormData): Promise<ApiResponse<LaborSafetyInstructionItem>> {
    const utcData = {
      ...data,
      date: convertToUtcDate(data.date),
    };
    return apiHelpers.post<LaborSafetyInstructionItem>('/LaborSafetyInstructionItem/Create', utcData);
  }

  // Обновить инструктаж по охране труда
  static async update(id: number, data: LaborSafetyInstructionItemFormData & { id: number }): Promise<ApiResponse<void>> {
    const utcData = {
      ...data,
      date: convertToUtcDate(data.date),
    };
    return apiHelpers.put<void>(`/LaborSafetyInstructionItem/Update/${id}`, utcData);
  }

  // Удалить инструктаж по охране труда
  static async delete(id: number): Promise<ApiResponse<void>> {
    return apiHelpers.delete<void>(`/LaborSafetyInstructionItem/Delete/${id}`);
  }
}